import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import React from "react";
var __jsx = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import uniqueId from 'lodash/uniqueId';
import { useMemo } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import Carousel from './Carousel';
import { GroupContainer } from './RepeatableField.style';
import { RepeatedField } from './RepeatedField';
import { prefixField } from './utils/prefixField';

// TODO: Test this component to check that keys doesn't change on Field addition/deletion
// TODO: Make this component generic to improve typing (ensure that name prop is correct)
var RepeatableField = function RepeatableField(_ref) {
  var formField = _ref.formField;

  var _useFormContext = useFormContext(),
      control = _useFormContext.control;

  var _useFieldArray = useFieldArray({
    control: control,
    name: formField.name
  }),
      fields = _useFieldArray.fields,
      append = _useFieldArray.append,
      remove = _useFieldArray.remove,
      move = _useFieldArray.move,
      insert = _useFieldArray.insert;

  var repeatedFields = useMemo(function () {
    // add an empty field if none exists
    var fieldsToMap = fields.length !== 0 ? fields : [{
      id: uniqueId()
    }];
    return fieldsToMap.map(function (repeatedField, index) {
      var _repeatedField$id;

      var id = (_repeatedField$id = repeatedField.id) !== null && _repeatedField$id !== void 0 ? _repeatedField$id : uniqueId();
      return _objectSpread({
        id: id
      }, prefixField(formField.field, "".concat(formField.name, "[").concat(index, "]."), id, fields));
    });
  }, [formField.field, fields, formField.name]);
  var isMaxReached = useMemo(function () {
    if (formField.max === undefined) {
      return false;
    }

    return repeatedFields.length >= formField.max;
  }, [formField.max, repeatedFields.length]);
  return __jsx(React.Fragment, null, formField.isCarousel === true && formField.fieldPreviewUrlPath !== undefined ? __jsx(Carousel, {
    repeatedFields: repeatedFields,
    repeatableFieldName: formField.name,
    fieldPreviewUrlPath: formField.fieldPreviewUrlPath,
    remove: remove,
    insert: isMaxReached ? undefined : insert,
    move: move,
    append: append
  }) : repeatedFields.map(function (repeatedField, index) {
    return __jsx(GroupContainer, {
      key: repeatedField.id
    }, __jsx(RepeatedField, {
      field: repeatedField,
      onRemove: index !== 0 ? function () {
        return remove(index);
      } : undefined,
      onAppend: index === repeatedFields.length - 1 && !isMaxReached ? function () {
        return append({});
      } : undefined
    }));
  }));
};

export default RepeatableField;